import type { Translator } from '@porotutu/i18n'
import type {
  FilterSelectSpec,
  FilterTextSpec,
} from '@porotutu/react/components/FilterBar/FilterBar'
import { ACTIONS, AUDIT_KINDS } from '../../vocabulary'
import type { AuditListQuery } from '../queries'

export const filtersFor = (t: Translator, query: AuditListQuery): FilterSelectSpec[] => [
  {
    name: 'kind',
    label: t('adm.audit.filters.kind_blank'),
    value: String(query.kind ?? ''),
    options: AUDIT_KINDS.map((kind) => ({ value: kind, label: t(`adm.audit.kind.${kind}`) })),
  },
  {
    name: 'action',
    label: t('adm.audit.filters.action_blank'),
    value: String(query.action ?? ''),
    options: ACTIONS.map((action) => ({ value: action, label: t(`adm.audit.action.${action}`) })),
  },
]

export const textsFor = (t: Translator, query: AuditListQuery): FilterTextSpec[] => [
  {
    name: 'subject_id',
    label: t('adm.audit.filters.subject_id'),
    value: query.subject_id ?? '',
    placeholder: t('adm.audit.filters.subject_id_placeholder'),
  },
]
